import type { GetServerSideProps } from "next";
import { type ApplicationPageProps, loadApplicationPageProps } from "../_app";
import * as 장치 from "../../components/장치";
import * as 마켓봄피쳐 from "../../components/데이터/마켓봄피쳐";
import { A, O, pipe } from "@mobily/ts-belt";

import { CSR } from "../../components/CSR";
import { 마켓봄_장점과_리드_Desktop } from "../../components/마켓봄_장점과_리드_Desktop";
import { 마켓봄_장점과_리드_Mobile } from "../../components/마켓봄_장점과_리드_Mobile";
import { LayoutSplitter } from "../../layouts/LayoutSplitter";

type 피쳐Props = {
  장치: 장치.t;
  마켓봄피쳐목록: readonly 마켓봄피쳐.마켓봄피쳐[];
} & ApplicationPageProps;

const 피쳐 = ({ 장치, 마켓봄피쳐목록 }: 피쳐Props) => {
  return (
    <CSR>
      <LayoutSplitter
        장치={장치}
        pc={<마켓봄_장점과_리드_Desktop 마켓봄피쳐목록={마켓봄피쳐목록} />}
        mobile={<마켓봄_장점과_리드_Mobile 마켓봄피쳐목록={마켓봄피쳐목록} />}
      />
    </CSR>
  );
};

export default 피쳐;

export const getServerSideProps: GetServerSideProps<
  피쳐Props & ApplicationPageProps
> = async (ctx) => {
  const applicationPageProps = await loadApplicationPageProps(ctx);
  const parseParam = (x: string): readonly string[] => JSON.parse(x);

  const featureList = pipe(
    ctx.query,
    O.flatMap((x) => x["featureList"] as string),
    O.flatMap((x: string) =>
      O.fromExecution<readonly string[]>(() => parseParam(x))
    ),
    O.map(A.filterMap(마켓봄피쳐.make)),
    O.getWithDefault<readonly 마켓봄피쳐.마켓봄피쳐[]>([])
  );

  return {
    props: {
      장치: 장치.fromContext(ctx),
      마켓봄피쳐목록: featureList,
      ...applicationPageProps,
    },
  };
};
